import { ShieldCheck } from "lucide-react";

export function AuthorityDetails({ hash }: { hash: string }) {
  return <details className="scratch-authority-details"><summary>Technical reference</summary><code>{hash}</code></details>;
}

export function SelectedAngleText({ text }: { text?: string }) {
  return text ? <p className="scratch-selected-angle">{text}</p> : null;
}

export function ScratchPreflightReceipt({ hash, initialized }: { hash: string; initialized: boolean }) {
  return <div className="scratch-authority-receipt"><div className="scratch-authority-receipt-heading"><ShieldCheck size={18} /><div><strong>Scratch authority resolved</strong><p>{initialized ? "Initialization submitted. Follow the ad in Kanban for current progress." : "No production work or provider spend exists yet."}</p></div></div><AuthorityDetails hash={hash} /></div>;
}
